<template>
    <ResultsNetworkBanner bannerType="warning" :header="(isTypeDentist ? 'In network' : '')">
      <span v-if="isTypeDentist">
        You must visit the dentist only at this location to receive in-network benefits. <span> Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.</span>
    </span>
    <span v-if="isTypeDental">
      <b>Some dentists here are in network, but others aren’t. </b> Use the dentist search to confirm the specific person or <a href="/my/contact/">call Member Services</a> to confirm before making an appointment. <span> Check your <a href="/my/plan-overview/coverage.html" :data-card-rank="rank">coverage details</a> to learn more.</span> 
    </span>
    </ResultsNetworkBanner>
</template>
<script setup>
const {  context } = useFCPModel()

const isTypeDentist = context.value?.type === 'dentist'
const isTypeDental = context.value?.type === 'dental'
const props = defineProps({
        result: Object,
        rank: Number
    })

</script>